// import React, { useState } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { registerAPI } from '../api';
// import { Lock, Mail, User, Building, FileText } from 'lucide-react';
// import SEO from '../components/SEO';

// const Register = () => {
//   const [formData, setFormData] = useState({
//       name: '', email: '', password: '', confirmPassword: '',
//       account_type: 'single', org_details: '', gst_number: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     if (formData.password !== formData.confirmPassword) {
//         return setError("Passwords do not match!");
//     }
//     setLoading(true);
//     try {
//       await registerAPI(formData);
//       alert("Registration Successful! Please Login.");
//       navigate('/login');
//     } catch (err) {
//       setError(err.response?.data?.message || "Registration Failed");
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="min-h-[80vh] flex items-center justify-center px-4 py-10">
//       <SEO title="Create Account" />
//       <div className="max-w-xl w-full bg-qrypt-card p-8 rounded-2xl border border-gray-700 shadow-2xl">
//         <h2 className="text-3xl font-bold text-center mb-6 text-white">Create Account</h2>
//         {error && <p className="text-red-500 text-center mb-4 font-semibold bg-red-500/10 p-2 rounded">{error}</p>}

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div className="flex gap-4 mb-4">
//               <button type="button" onClick={()=>setFormData({...formData, account_type: 'single'})} className={`flex-1 py-2 rounded-lg font-bold border transition ${formData.account_type === 'single' ? 'bg-qrypt-primary border-qrypt-primary text-white' : 'border-gray-600 text-gray-400 hover:text-white'}`}>Single User</button>
//               <button type="button" onClick={()=>setFormData({...formData, account_type: 'organisation'})} className={`flex-1 py-2 rounded-lg font-bold border transition ${formData.account_type === 'organisation' ? 'bg-qrypt-primary border-qrypt-primary text-white' : 'border-gray-600 text-gray-400 hover:text-white'}`}>Organisation</button>
//           </div>

//           <div className="relative"><User className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//             <input type="text" placeholder="Full Name" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
//           </div>
//           <div className="relative"><Mail className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//             <input type="email" placeholder="Email Address" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required />
//           </div>

//           {formData.account_type === 'organisation' && (
//               <>
//                 <div className="relative"><Building className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//                   <input type="text" placeholder="Organisation Name" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none" value={formData.org_details} onChange={(e) => setFormData({...formData, org_details: e.target.value})} required />
//                 </div>
//                 <div className="relative"><FileText className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//                   <input type="text" placeholder="GST Number (Optional)" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none uppercase" value={formData.gst_number} onChange={(e) => setFormData({...formData, gst_number: e.target.value})} />
//                 </div>
//               </>
//           )}

//           <div className="grid grid-cols-2 gap-4">
//               <div className="relative"><Lock className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//                 <input type="password" placeholder="Password" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} required minLength={6}/>
//               </div>
//               <div className="relative"><Lock className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
//                 <input type="password" placeholder="Confirm Password" className="w-full bg-gray-800 border border-gray-700 rounded-lg py-3 pl-10 text-white focus:border-qrypt-primary outline-none" value={formData.confirmPassword} onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})} required />
//               </div>
//           </div>

//           <button type="submit" disabled={loading} className="w-full bg-qrypt-primary hover:bg-blue-600 disabled:bg-gray-600 text-white font-bold py-3 rounded-lg transition shadow-lg mt-4">
//             {loading ? "Creating Account..." : "Sign Up"}
//           </button>
//         </form>
//         <p className="mt-6 text-center text-gray-400 text-sm">
//           Already have an account? <Link to="/login" className="text-qrypt-primary hover:underline font-bold ml-1">Login here</Link>
//         </p>
//       </div>
//     </div>
//   );
// };
// export default Register;

// change code 25/02/2026
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerAPI } from "../api";
import {
  Lock,
  Mail,
  User,
  Building,
  FileText,
  ShieldCheck,
  ArrowRight,
  Loader2,
  Eye,
  EyeOff,
} from "lucide-react";
import SEO from "../components/SEO";

// 1. INPUT FIELD KO COMPONENT KE BAHAR MOVE KIYA (FOCUS ISSUE FIX)
const InputField = ({ icon: Icon, ...props }) => (
  <div className="relative group">
    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
      <Icon className="h-5 w-5 text-gray-500 group-focus-within:text-blue-400 transition-colors" />
    </div>
    <input
      {...props}
      className="block w-full pl-11 pr-4 py-3.5 bg-slate-900/50 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all duration-200"
    />
  </div>
);

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    account_type: "single",
    org_details: "",
    gst_number: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  // Helper function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }
    setLoading(true);
    try {
      await registerAPI(formData);
      alert("Registration Successful! Please Login.");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration Failed");
    }
    setLoading(false);
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 py-20 overflow-hidden bg-[#0B0F19]">
      <SEO title="Create Account - QryptShield" />

      {/* Background decoration */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `linear-gradient(to right, #ffffff60 1px, transparent 1px), linear-gradient(to bottom, #ffffff60 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-600/10 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 w-full max-w-xl mt-12">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-blue-600/20 border border-blue-500/30 mb-4">
            <ShieldCheck className="w-7 h-7 text-blue-400" />
          </div>
          <h2 className="text-3xl font-bold text-white">Create Account</h2>
          <p className="text-gray-400 mt-2">
            Join the post-quantum secure network
          </p>
        </div>

        <div className="bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl p-8">
          {error && (
            <div className="mb-6 p-4 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm text-center flex items-center justify-center gap-2">
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Account Type Toggle */}
            <div className="p-1 bg-slate-900/50 rounded-xl border border-white/5 flex mb-6">
              <button
                type="button"
                onClick={() =>
                  setFormData((prev) => ({ ...prev, account_type: "single" }))
                }
                className={`flex-1 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                  formData.account_type === "single"
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-500/25"
                    : "text-gray-400 hover:text-white"
                }`}
              >
                Individual
              </button>
              <button
                type="button"
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    account_type: "organisation",
                  }))
                }
                className={`flex-1 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                  formData.account_type === "organisation"
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-500/25"
                    : "text-gray-400 hover:text-white"
                }`}
              >
                Organization
              </button>
            </div>

            <div className="space-y-4">
              <InputField
                icon={User}
                type="text"
                placeholder="Full Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <InputField
                icon={Mail}
                type="email"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {formData.account_type === "organisation" && (
              <div className="space-y-4 pt-2">
                <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold">
                  Company Details
                </p>
                <InputField
                  icon={Building}
                  type="text"
                  placeholder="Company Name"
                  name="org_details"
                  value={formData.org_details}
                  onChange={handleChange}
                  required
                />
                <InputField
                  icon={FileText}
                  type="text"
                  placeholder="GST Number (Optional)"
                  name="gst_number"
                  value={formData.gst_number}
                  onChange={handleChange}
                />
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Password Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  className="block w-full pl-11 pr-11 py-3.5 bg-slate-900/50 border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={6}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-500 hover:text-white"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              {/* Confirm Password Field */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-500" />
                </div>
                <input
                  type={showConfirm ? "text" : "password"}
                  placeholder="Confirm"
                  name="confirmPassword"
                  className="block w-full pl-11 pr-11 py-3.5 bg-slate-900/50 border border-white/10 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirm(!showConfirm)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-500 hover:text-white"
                >
                  {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-6 flex justify-center items-center py-3.5 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-xl text-white font-bold hover:from-blue-500 hover:to-cyan-500 transition-all shadow-lg disabled:opacity-70"
            >
              {loading ? (
                <Loader2 className="animate-spin mr-2" />
              ) : (
                "Get Started"
              )}
              {!loading && <ArrowRight className="ml-2 h-4 w-4" />}
            </button>
          </form>

          <div className="mt-8 text-center border-t border-white/5 pt-6">
            <p className="text-gray-400 text-sm">
              Already have an account?{" "}
              <Link
                to="/login"
                className="font-semibold text-blue-400 hover:underline"
              >
                Log in here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
